import React, { useState } from 'react';
import { CourseModuleAboutCardActivity } from './course-module-about-card-activity';
import { EmptyState } from '@/components/custom/empty-state';
import { t } from 'i18next';
import { Filter, FilterInput } from '@/components/custom/filter';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function CourseModuleAboutTabActivities({ currentModule }) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredActivities = currentModule?.['learning-system-activities']
    ?.map(item => item.activity)
    .filter(activity => {
      if (searchTerm == '') {
        return activity;
      }
      if (activity.title !== null && activity.title.toLowerCase().includes(searchTerm.toLocaleLowerCase())) {
        return activity;
      }
    });

  const isSomeRequirementNotFinished = currentModule?.['learning-system-requirements']?.some(item => !item.finished);

  return (
    <div className="animate-fade-in">
      <Filter>
        <FilterInput
          label={t('textsCommon.search')}
          placeholder="Pesquisar uma atividade"
          type="search"
          name="search"
          id="search"
          onChange={e => setSearchTerm(e.target.value)}
        />
      </Filter>

      {filteredActivities && filteredActivities.length > 0 ? (
        <Table className="min-w-[620px]">
          <TableHeader>
            <TableRow>
              <TableHead scope="col">Atividade</TableHead>
              <TableHead
                scope="col"
                className="w-[160px]"
              >
                Status
              </TableHead>
              <TableHead
                scope="col"
                className="w-[170px]"
              />
            </TableRow>
          </TableHeader>

          <TableBody>
            {filteredActivities.map(activity => {
              return (
                <CourseModuleAboutCardActivity
                  key={activity.id}
                  activity={activity}
                  isNotFinished={isSomeRequirementNotFinished}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <EmptyState type="data" />
      )}
    </div>
  );
}
